exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".user--container{padding-top:15px;height:50px}@media (min-width:992px){.user--container{padding-top:0;height:79px}}.user--container:hover{background-color:#ffcb8b;cursor:pointer;opacity:1}@media (min-width:992px){.user{margin-top:30px}}.user--icon{padding-right:5px}.user--name{font-family:Open Sans,sans-serif;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/components/user/user.styl
// module id = 762
// module chunks = 0